<template>
    <div class="patsnap-biz-email_alert__common">
        <Layout
            class="pz-biz-email_alert__item"
            :mode="service.titleLayout"
        >
            <span>{{ $t('emailAlertBiz.common.commonModule.sendTo') }}</span>
            <slot name="tips" />
            <template #content>
                <!-- 发送给自己 & 微信绑定 -->
                <div class="pz-biz-email_alert__send-to">
                    <!-- 发送给自己 -->
                    <div
                        v-if="service.hasSendToMe && service.selfEmail"
                        class="pz-biz-email_alert__checkbox"
                    >
                        <!-- eslint-disable vue/no-mutating-props -->
                        <Checkbox
                            :checked="service.sendToMe"
                            @change="changeSendToMeStatus"
                        >
                            {{ service.sendToMeDisplayLabel
                                || service.selfEmail }} ({{
                                $t('emailAlertBiz.common.commonModule.self')
                            }})
                        </Checkbox>
                    </div>
                    <!-- 微信绑定 -->
                    <slot name="wechat" />
                </div>
                <!-- email -->
                <EmailAutoComplete
                    :class="{ 'pz-biz-email_alert__other-email': true, 'error': !isAllEmailValid }"
                    :loading="service.innerLoading || service.outLoading"
                    :inputing.sync="service.currentInputtingEmail"
                    :selected.sync="service.selectedEmails"
                    :passport-url="service.passportUrl"
                    :get-email-list="getEmailList"
                    :scroll-selector="service.completeScrollSelector"
                    :placeholder-content="service.emailAutoCompletePlaceholder
                        || $t('emailAlertBiz.common.emailAutoComplete.sendToTip')"
                    :email-limit-num="service.emailLimitNum"
                    :show-limit-label="service.showLimitLabel"
                    :enable-select-when-over-limit="service.enableSelectWhenOverLimit"
                    @onEmailUpperLimit="onEmailUpperLimit"
                    @updateCurrentSelectedEmailCount="updateCurrentSelectedEmailCount"
                />
                <!--email非法校验-->
                <div
                    v-if="!isAllEmailValid"
                    class="pz-biz-email_alert__email-errmsg"
                >
                    {{ $t('emailAlertBiz.common.commonModule.errorEmail') }}
                </div>
                <!--是否经过他人允许-->
                <div
                    v-if="showEmailToOtherTips"
                    :class="{ 'pz-biz-email_alert__other-tips': true,
                              'pz-biz-email_alert__other-tips--error': isSentToOtherTipUnchecked }"
                >
                    <div class="pt-email-alert__container-checkbox">
                        <Checkbox
                            :checked="service.sendToOther"
                            @change="changeSendToOtherStauts"
                        >
                            {{ $t('emailAlertBiz.common.commonModule.emailToOtherTips') }}
                        </Checkbox>
                    </div>
                </div>
                <!-- 退订 -->
                <slot name="unsubscribed" />
                <slot name="extra" />
            </template>
        </Layout>
        <Layout
            class="pz-biz-email_alert__item"
            :mode="service.titleLayout"
        >
            <span>{{ $t('emailAlertBiz.common.commonModule.frequency') }}</span>
            <template #content>
                <!-- 提醒频次 -->
                <AlertFrequency
                    v-model="service.alertFrequency"
                    :filter-type="service.filterFreqType"
                    :freq-initial-type="service.freqInitialType"
                    :options="service.alertFrequencyOptions"
                />
                <!-- 无更新发送 -->
                <div class="pz-biz-email_alert__checkbox pz-biz-email_alert__no-update">
                    <Checkbox
                        :checked="service.alertNoUpdate"
                        @change="changeAlertNoUpdateStauts"
                    >
                        {{ $t('emailAlertBiz.common.commonModule.alertNoUpdate') }}
                    </Checkbox>
                </div>
            </template>
        </Layout>
    </div>
</template>

<script>
/* eslint-disable vue/no-mutating-props */
/* eslint-disable max-len */
import {
    map, filter, uniq, indexOf,
} from 'lodash';
import Layout from './Layout';
import Checkbox from './Checkbox.vue';
import EmailAutoComplete from './EmailAutoComplete';
import AlertFrequency from './AlertFrequency.vue';

export default {
    components: {
        Layout,
        Checkbox,
        EmailAutoComplete,
        AlertFrequency,
    },
    props: {
        service: {
            type: Object,
            required: true,
            default: () => {},
        },
        isAllEmailValid: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
        };
    },
    computed: {
        showEmailToOtherTips() {
            if (!this.isAllEmailValid) return false;
            let allOtherEmails = map(filter(this.service.selectedEmails, (item) => item.type === 'email'), 'value');
            let allOtherGroups = map(filter(this.service.selectedEmails, (item) => item.type === 'group'), 'value');
            allOtherEmails = uniq(allOtherEmails);
            allOtherGroups = uniq(allOtherGroups);
            if ((allOtherEmails.length === 0 || (allOtherEmails.length === 1 && indexOf(allOtherEmails, this.selfEmail) > -1)) && allOtherGroups.length === 0) return false;
            return true;
        },
        isSentToOtherTipUnchecked() {
            return !this.service.shouldSubmit && this.showEmailToOtherTips && !this.service.sendToOther;
        },
    },
    watch: {
        'service.sendToOther': {
            handler(val) {
                if (val) {
                    this.service.shouldSubmit = true;
                }
            },
        },
        'service.selectedEmails': {
            handler(newVal) {
                if (newVal && !newVal.length && this.service.sendToOther) {
                    this.service.setSendToOtherStatus(false);
                }
            },
        },
    },
    created() {
    },
    methods: {
        /* 解决service中this指向vue组件的问题 */
        getEmailList(keyword) {
            return this.service.getEmailList(keyword);
        },
        onEmailUpperLimit() {
            this.service.onEmailUpperLimit();
        },
        updateCurrentSelectedEmailCount(count) {
            this.service.updateCurrentSelectedEmailCount(count);
        },
        changeSendToMeStatus(status) {
            this.service.setSendToMeStatus(status);
        },
        changeSendToOtherStauts(status) {
            this.service.setSendToOtherStatus(status);
        },
        changeAlertNoUpdateStauts(status) {
            this.service.setAlertNoUpdateStatus(status);
        },
    },
};
</script>
